module.exports = __webpack_public_path__ + "img/sprint.3cf68f88.svg";